var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailTranscriptIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.028,
    height: 17,
    viewBox: "0 0 17.028 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "prefix__email-transcript",
    d: "M13.48 6.441S9.8 6.2 8.514 7.816A7.4 7.4 0 0 1 13.48 3.6V2.184l3.547 2.838-3.547 2.851V6.441zM.018 17.039h16.99L8.514 8.8l-8.5 8.235zm1.187-9.933l7.3-5.313 2.166 1.574a10.209 10.209 0 0 1 1.386-.748L8.507.039 0 6.229v8.852l5.216-5.057-4.011-2.918zm11.177 3.471l4.646 4.5V6.842l-4.646 3.735z",
    transform: "translate(0 -.039)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTranscriptIcon);
export default __webpack_public_path__ + "static/media/EmailTranscriptIcon.ed56763bc2ea876fd1fad823e3271d7d.svg";
export { ForwardRef as ReactComponent };